import React from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useQueueRegistry } from '../queues/queue-registry/use-queue-registry';
import { UnitTimersStore } from './unit-timers-store';
import { UnitTimersStoreContext } from './unit-timers-store-context';
import { usePlaySound } from '../sounds/play-sound-provider';
import { useApplicationType } from '../common/hooks/use-application-type';

export function UnitTimersStoreProvider({
    unitTimersStore,
    children,
}: {
    unitTimersStore?: UnitTimersStore;
    children: React.ReactElement;
}): React.ReactElement {
    const queueRegistry = useQueueRegistry();
    const enabledFeatures = useEnabledFeatures();
    const { playSound } = usePlaySound();
    const { isCad } = useApplicationType();

    const value: UnitTimersStore = React.useState(
        () =>
            unitTimersStore ||
            new UnitTimersStore((unitId: number): void => {
                const unitQueueStores = queueRegistry.getUnitQueueStores();
                if (
                    isCad &&
                    enabledFeatures.dispatchPlayAlertOnUnitStatusTimerExpiration &&
                    unitQueueStores.some((unitQueueStore) => unitQueueStore.isRowInList(unitId))
                ) {
                    playSound('unit-timer-alert');
                }
            })
    )[0];
    return (
        <UnitTimersStoreContext.Provider value={value}>{children}</UnitTimersStoreContext.Provider>
    );
}
